import React, { memo, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Card, ListItem, Typography, ListItemAvatar } from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { connectionsStyle } from "./connections.helper";
import { clientTypeConstants } from "../../../interaction/constants/clientType.constants";
function connectionsComparer(prevProps, props) {
  return prevProps.template === props.template && prevProps.connectionList && prevProps.connectionList.length === props.connectionList.length
}
const ConnectionsModule = memo(({ eventId, lang, channel, template, preview, connectionList = [] }) => {
  // const { eventId, lang, channel, template, preview, connectionList = [] } = props;
  useEffect(() => {
    init(eventId, "DigitalMeeting.Connections", lang);
  }, []);
  const { background, borderRadius, borderWidth, borderColor, borderStyle, fontSize, fontWeight, fontFamily, color } = connectionsStyle(template);

  let connections = useMemo(() => {
    if (preview) return 106;
    return connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MEETING && cl.channel == channel).length;
  }, [connectionList]);
  return (
    <div
      style={{
        background,
        borderRadius,
        borderWidth,
        borderColor,
        borderStyle: "solid",
        padding: "0px",
        margin: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <ListItem style={{ width: "100%", height: "100%", fontFamily: fontFamily }}>
        <ListItemAvatar style={{ minWidth: 35 }}>
          <PeopleIcon style={{ color }} />
        </ListItemAvatar>
        <div style={{ display: "flex", fontFamily: fontFamily, paddingRight: 22 }}>
          <div
            style={{
              fontSize,
              fontWeight,
              fontFamily: "Anton !important",
              color,
              marginRight: 10,
            }}
          >
            {connections}
          </div>
          <div
            style={{
              fontSize,
              fontWeight,
              fontFamily: fontFamily,
              color,
            }}
          >
            <EventLabel2 name="Connections" groupName="DigitalMeeting.Connections" />
          </div>
        </div>
      </ListItem>
    </div>
  );
},connectionsComparer);

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(ConnectionsModule);
